import Pagination from "react-js-pagination";

const PaginationLinks = ({ paginationData, getNextPage }) => {
  // const { current_page, per_page, total } = paginationData
  
  return (
    <>
      <div className='d-flex justify-content-end'>
        <Pagination
          activePage={paginationData?.current_page}
          totalItemsCount={paginationData?.total}
          itemsCountPerPage={paginationData?.per_page}
          onChange={(pageNumber) => getNextPage(pageNumber)}
          pageRangeDisplayed={10}
          linkClass='page-link'
          itemClass='page-item'
          firstPageText='First'
          lastPageText='Last'
        />
      </div>
    </>
  );
};

export default PaginationLinks;
